(() => {
  // Tiroir de menu
  const tiroir = document.getElementById('tiroir');
  const burger = document.querySelector('.burger');
  const basculer = (ouvert) => {
    tiroir.classList.toggle('ouvert', ouvert);
    tiroir.setAttribute('aria-hidden', !ouvert);
    burger.setAttribute('aria-expanded', ouvert);
    document.body.style.overflow = ouvert ? 'hidden' : '';
  };
  burger?.addEventListener('click', () => basculer(true));
  tiroir?.addEventListener('click', (e) => { if (e.target.closest('[data-fermer]') || e.target.closest('nav a')) basculer(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && tiroir?.classList.contains('ouvert')) basculer(false); });

  // Apparition douce au défilement
  const io = 'IntersectionObserver' in window && new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('visible'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.apparait').forEach((el) => (io ? io.observe(el) : el.classList.add('visible')));

  // --- Fiche produit : à l'unité ou pack de 3 ---
  const fiche = document.getElementById('fiche');
  if (!fiche) return;

  const P = JSON.parse(document.getElementById('produit-json').textContent);
  const HEX = JSON.parse(document.getElementById('pastilles-json').textContent || '{}');
  const iCol = P.options.findIndex((o) => (o.name || o) === 'Coloris');
  const iTai = P.options.findIndex((o) => (o.name || o) === 'Taille');
  const opt = (v, i) => v.options[i];
  const couleurs = [...new Set(P.variants.map((v) => opt(v, iCol)))];
  const tailles = [...new Set(P.variants.map((v) => opt(v, iTai)))];
  const variante = (c, t) => P.variants.find((v) => opt(v, iCol) === c && opt(v, iTai) === t);
  const euros = (cents) => new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0,
  }).format(cents / 100);

  const params = new URLSearchParams(location.search);
  const vInit = P.variants.find((v) => String(v.id) === params.get('variant'));
  const cInit = vInit ? opt(vInit, iCol) : couleurs[0];
  const etat = {
    format: params.get('offre') === 'pack3' ? 'pack3' : 'unite',
    unite: { couleur: cInit, taille: vInit ? opt(vInit, iTai) : null },
    pack: [0, 1, 2].map((i) => ({ couleur: couleurs[i % couleurs.length], taille: 'M' })),
  };
  const prixUnite = P.price;
  const pack = Number(fiche.dataset.pack);
  const piece = Number(fiche.dataset.piece);
  const $ = (s) => fiche.querySelector(s);
  const galerieEl = document.getElementById('galerie');
  const src = (m) => (m.src || m.preview_image?.src || '').replace(/^\/\//, 'https://');
  const taille = (u, w) => u + (u.includes('?') ? '&' : '?') + 'width=' + w;

  // Photos d'un coloris : celles dont le texte alternatif cite le coloris (mises en scène puis vues produit)
  const imagesDe = (c) => {
    const imgs = P.media.filter((m) => m.media_type === 'image');
    const parAlt = imgs.filter((m) => (m.alt || '').includes(c));
    return parAlt.length ? parAlt : imgs.slice(0, 3);
  };
  let derniere = null;
  function galerie() {
    const c = etat.format === 'unite' ? etat.unite.couleur : etat.pack[0].couleur;
    const cle = etat.format === 'unite' ? c : 'pack:' + etat.pack.map((p) => p.couleur).join();
    if (cle === derniere) return;
    derniere = cle;
    let imgs;
    if (etat.format === 'unite') imgs = imagesDe(c);
    else {
      // Pack : la photo des quatre coloris, puis une mise en scène par coloris choisi
      const tous = P.media.filter((m) => m.media_type === 'image');
      const quatuor = tous.find((m) => /quatre coloris/i.test(m.alt || ''));
      imgs = [quatuor, ...[...new Set(etat.pack.map((p) => p.couleur))].map((x) => imagesDe(x)[0])].filter(Boolean);
    }
    galerieEl.innerHTML = imgs.map((m, i) =>
      `<figure><img src="${taille(src(m), 1400)}" alt="${(m.alt || P.title).replace(/"/g, '&quot;')}" ${i ? 'loading="lazy"' : ''}></figure>`).join('');
    galerieEl.scrollLeft = 0;
  }

  function rendu() {
    fiche.querySelectorAll('.format').forEach((b) => b.setAttribute('aria-pressed', b.dataset.format === etat.format));
    $('#bloc-unite').hidden = etat.format !== 'unite';
    $('#bloc-pack').hidden = etat.format !== 'pack3';
    $('#prix').innerHTML = etat.format === 'unite'
      ? euros(prixUnite)
      : `${euros(pack)} <s>${euros(prixUnite * 3)}</s><small>soit ${euros(piece)} la pièce · livraison offerte</small>`;

    const u = etat.unite;
    $('#nom-couleur').textContent = u.couleur;
    $('#pastilles').innerHTML = couleurs.map((c) =>
      `<button type="button" class="pastille" style="background:${HEX[c] || '#ccc'}" aria-label="${c}" aria-pressed="${c === u.couleur}" data-c="${c}"></button>`).join('');
    $('#tailles').innerHTML = tailles.map((t) => {
      const v = variante(u.couleur, t);
      return `<button type="button" class="taille" aria-pressed="${t === u.taille}" data-t="${t}" ${v && v.available ? '' : 'disabled style="opacity:.35"'}>${t}</button>`;
    }).join('');

    $('#slots').innerHTML = etat.pack.map((p, i) => `
      <div class="slot"><span class="num">${i + 1}</span>
        <select data-slot="${i}" data-champ="couleur" aria-label="Coloris pièce ${i + 1}">
          ${couleurs.map((c) => `<option ${c === p.couleur ? 'selected' : ''}>${c}</option>`).join('')}
        </select>
        <select data-slot="${i}" data-champ="taille" aria-label="Taille pièce ${i + 1}">
          ${tailles.map((t) => `<option ${t === p.taille ? 'selected' : ''}>${t}</option>`).join('')}
        </select>
      </div>`).join('');

    const pret = etat.format === 'pack3' || u.taille;
    $('#cta').textContent = etat.format === 'unite'
      ? (pret ? `Ajouter au panier · ${euros(prixUnite)}` : 'Choisissez votre taille')
      : `Ajouter le trio · ${euros(pack)}`;
    $('#cta').disabled = !pret;
    galerie();
  }

  fiche.addEventListener('click', (e) => {
    const f = e.target.closest('.format'); if (f) { etat.format = f.dataset.format; rendu(); return; }
    const p = e.target.closest('.pastille'); if (p) { etat.unite.couleur = p.dataset.c; rendu(); return; }
    const t = e.target.closest('.taille'); if (t && !t.disabled) { etat.unite.taille = t.dataset.t; rendu(); }
  });
  fiche.addEventListener('change', (e) => {
    const s = e.target.closest('select[data-slot]'); if (!s) return;
    etat.pack[s.dataset.slot][s.dataset.champ] = s.value;
    rendu();
  });

  $('#cta').addEventListener('click', async () => {
    const err = $('#erreur'); err.hidden = true;
    const choix = etat.format === 'unite' ? [etat.unite] : etat.pack;
    const items = [];
    for (const c of choix) {
      const v = variante(c.couleur, c.taille);
      if (!v || !v.available) { err.textContent = `${c.couleur} ${c.taille} n'est pas disponible.`; err.hidden = false; return; }
      const deja = items.find((x) => x.id === v.id);
      if (deja) deja.quantity += 1; else items.push({ id: v.id, quantity: 1 });
    }
    $('#cta').disabled = true;
    try {
      const racine = window.Shopify?.routes?.root || '/';
      const r = await fetch(racine + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error((await r.json()).description || 'Erreur');
      location.href = racine + 'cart';
    } catch (e) {
      err.textContent = `Impossible d'ajouter au panier : ${e.message}`; err.hidden = false; $('#cta').disabled = false;
    }
  });

  rendu();
})();
